var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('span',_vm._g({staticClass:"d-inline-flex mr-1"},on),[_c('katki-paneli-button',{on:{"click":_vm.openAnket}})],1)]}}])},[_c('span',[_vm._v("Zirve Cloud Geliştirme Katkı Paneli")])])
}
var staticRenderFns = []

export { render, staticRenderFns }